export const isAuthenticated = () => {
    // const token = localStorage.getItem("token");
    // if (token) {
    //     return true
    // } else {
    //     return false
    // }
    return !!localStorage.getItem("token");
};

export const getUserRole = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.role?.name || null;
};